import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import Restricted from '../../common/restricted'

import List from './output-list/list'
import Table from './output-table/table'

class Output extends Component {
  constructor(props) {
    super(props)

    this.state = {
      listView: false,
      fullView: false
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { rider } = nextProps

    if (rider !== this.props.rider) return true
    if (nextState !== this.state) return true
    return false
  }

  render() {
    const { view, rider, stageElements } = this.props
    const { listView, fullView } = this.state

    const className = classnames({
      'output': true,
      'output-list': listView === true,
      'output-table': listView === false,
      'section--full': fullView
    })

    const enlargeButtonClassName = classnames({
      'button--success': true,
      'enlarge-button': true,
      'enlarge-button--active': fullView === true
    })

    return (
      <section className={className}>
        <div className="section-head">
          <h2>Output {listView ? 'List' : 'Table'}</h2>

          {/*<button className="view-button button--success" onClick={() => this.setState({listView: !listView, fullView: false})}>
            {
              listView
              ? 'Switch to Table view'
              : 'Switch to List view'
            }
          </button>*/}

          {
            !listView
            ? <button className={enlargeButtonClassName} onClick={() => this.setState({fullView: !fullView})} />
            : null
          }
        </div>

        {
          view.loggedIn
          ? listView
            ? <List
                group={this.props.group}
                items={rider.items}
                itemGroups={rider.itemGroups}
                addRiderItem={this.props.addRiderItem}
                removeRiderItem={this.props.removeRiderItem}
                createRiderItem={this.props.createRiderItem}
                editRiderItem={this.props.editRiderItem}
                moveRiderItem={this.props.moveRiderItem}
                stageElements={stageElements}
                createStageElement={this.props.createStageElement}
                getSearchResults={this.props.getSearchResults} />
            : <Table
                view={view}
                editable={true}
                fullView={fullView}
                group={this.props.group}
                columns={rider.columns}
                moveRiderColumn={this.props.moveRiderColumn}
                items={rider.items}
                itemGroups={rider.itemGroups}
                inputItems={rider.input}
                addRiderItem={this.props.addRiderItem}
                removeRiderItem={this.props.removeRiderItem}
                createRiderItem={this.props.createRiderItem}
                createRiderItems={this.props.createRiderItems}
                cloneRiderItem={this.props.cloneRiderItem}
                editRiderItem={this.props.editRiderItem}
                deleteRiderItem={this.props.deleteRiderItem}
                deleteRiderItemGroup={this.props.deleteRiderItemGroup}
                moveRiderItem={this.props.moveRiderItem}
                members={rider.members}
                stageElements={stageElements}
                createStageElement={this.props.createStageElement}
                getSearchResults={this.props.getSearchResults} />
          : <Restricted
              section="Output List"
              setModal={this.props.setModal} />
        }
      </section>
    )
  }
}

Output.propTypes = {
  view: PropTypes.object,
  group: PropTypes.string,
  rider: PropTypes.object,
  moveRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  cloneRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  deleteRiderItemGroup: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func,
  setModal: PropTypes.func
}

Output.defaultProps = {
  view: {},
  group: '',
  rider: { isFetching: true },
  moveRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  cloneRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  deleteRiderItemGroup: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {},
  setModal: function() {}
}

export default Output



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output.js